export enum PetSize {
  XS = 'XS',
  SM = 'SM',
  M = 'M',
  L = 'L',
  XL = 'XL',
  G = 'G', // G represents Giant
  UNK = 'UNK',
}

export interface PetBreed {
  id: number;
  name: string;
  type: PetType;
  markForDelete?: boolean;
  sizeType?: PetSize;
}

export interface PetType {
  id: number;
  name: string;
  markForDelete?: boolean;
}

export enum PolicyPetStatus {
  DELETED = 'DELETED',
  ACTIVE = 'ACTIVE',
  MEMORIALIZED = 'INACTIVE',
}

export enum PetGenderCode {
  FEMALE = 'FEMALE',
  FMLE = 'FMLE',
  MALE = 'MALE',
  UNKN = 'UNKN',
  UNKNOWN = 'UNKNOWN',
}

export enum PetGenderName {
  FEMALE = 'female',
  MALE = 'male',
  NEUTERED_MALE = 'neutered male',
  SPAYED_FEMALE = 'spayed female',
}

export enum PetSterilizationName {
  YES = 'yes',
  NO = 'no',
}

export enum PetAgeRange {
  NEWBORN_0 = '0-2 months old',
  NEWBORN_1 = '2-4 months old',
  NEWBORN_2 = '4-6 months old',
  NEWBORN_3 = '6-8 months old',
  NEWBORN_4 = '8-10 months old',
  NEWBORN_5 = '10-12 months old',
  ADULT_1 = '1 year old',
  ADULT_2 = '2 years old',
  ADULT_3 = '3 years old',
  ADULT_4 = '4 years old',
  ADULT_5 = '5 years old',
  ADULT_6 = '6 years old',
  ADULT_7 = '7 years old',
  ADULT_8 = '8 years old',
  ADULT_9 = '9 years old',
  ADULT_10 = '10 years old',
  ADULT_11 = '11 years old',
  ADULT_12 = '12 years old',
  ADULT_13 = '13 years old',
  ADULT_14 = '14 years old',
  ADULT_15 = '15+ years old',
}
export interface PetProfile {
  adopted: boolean;
  adoptionDate?: string;
  allergies?: any[];
  avatar?: {
    url: string;
  };
  birthday: string;
  petAgeRange?: PetAgeRange;
  birthdayEstimated: boolean;
  breed: PetBreed;
  breeds: PetBreed[];
  existingMedicalConditions?: any[];
  gender: PetGenderCode;
  iconPhoto?: { photoUrl: string };
  id: number;
  medications?: any[];
  medicationAllergies?: any[];
  name: string;
  userId: number;
  userEmail?: string;
  sterilization: boolean;
  status: PolicyPetStatus;
  type: PetType;
  weight: number;
  fullGrownSizeType?: PetSize;
}

// Used by pet form to manage internal state
export interface PetFormDetails {
  birthday?: Date;
  invalidFields: Record<string, string>;
  allBreeds: PetBreed[];
  breedName: string;
  secondBreedName: string;
  showBreedCountError: boolean;
}

export enum PetFormType {
  EDIT = 'EDIT',
  EDIT_DRAWER = 'EDIT_DRAWER',
  NEW = 'NEW',
  GUEST = 'GUEST',
  INCOMPLETE = 'INCOMPLETE',
  AFFILIATE = 'AFFILIATE',
}

export enum PetFormContent {
  HEADER = 'HEADER',
  SUBHEADER = 'SUBHEADER',
  ANIMAL_TYPE = 'ANIMAL_TYPE',
  GENDER_SELECTED_VALUE = 'GENDER_SELECTED_VALUE',
  STERILIZATION_SELECTED_VALUE = 'STERILIZATION_SELECTED_VALUE',
  GENDER_ON_CHANGE = 'GENDER_ON_CHANGE',
  STERILIZATION_ON_CHANGE = 'STERILIZATION_ON_CHANGE',
  BIRTHDAY_DROPDOWN_ON_CHANGE = 'BIRTHDAY_DROPDOWN_ON_CHANGE',
  EMAIL = 'EMAIL',
}

export enum ExistingCustomerModalContent {
  TITLE = 'TITLE',
  DESCRIPTION = 'DESCRIPTION',
  PET = 'PET',
  PRIMARY_CTA = 'PRIMARY_CTA',
  SECONDARY_CTA = 'SECONDARY_CTA',
}

export interface PetFormQueryData {
  type: PetType;
  name: string;
  gender: PetGenderCode;
  sterilization: boolean;
  birthday: string;
  petAgeRange?: PetAgeRange;
  breedId: number;
  breedsIds: number[];
  weight: number;
  fullGrownSizeType?: PetSize;
}

export enum EditPetDrawerType {
  INCOMPLETE = 'INCOMPLETE',
  PET_SUMMARY = 'PET_SUMMARY',
}
